import React from 'react';

import { CountryDropdown } from '../../components/CountryDropdown';
import { WorldMap } from '../../country/WorldMap';
import { useCustomizer } from '../../store/customizer';
import {
  DesktopBody,
  DropdownSlot,
  MapSlot,
  MobileBody,
  Heading,
  Subtext,
  MobileDropdownSlot,
  MobileMapSlot,
} from './country.styles';

/**
 * Step 1 — Operating Area. Desktop: the region dropdown above the dimmed world
 * map (the surrounding header / progress panel / footer are the shell's). Mobile:
 * a heading + subtext + dropdown + map (the progress chrome + CTA are the mobile
 * shell's).
 */
export const CountryStep = (): React.ReactElement => {
  const { isMobile, country } = useCustomizer();
  const selected = country?.code ?? null;

  if (isMobile) {
    return (
      <MobileBody>
        <Heading text="Confirm website's operating region" tag="h1" />
        <Subtext text="Your website's operating region cannot be changed later." tag="paragraph" />
        <MobileDropdownSlot>
          <CountryDropdown />
        </MobileDropdownSlot>
        <MobileMapSlot>
          <WorldMap selected={selected} />
        </MobileMapSlot>
      </MobileBody>
    );
  }

  return (
    <DesktopBody>
      <DropdownSlot>
        <CountryDropdown />
      </DropdownSlot>
      <MapSlot>
        <WorldMap selected={selected} />
      </MapSlot>
    </DesktopBody>
  );
};

export default CountryStep;